import DashboardWallet from './DashboardWallet';
export default DashboardWallet;
